// collection all page swatches

$(".custom_swatch span").click(function(){  
   var col = $(this).attr("data-color");
   var selected_val = $(this).parents('.items_grid').find('.custom-selector option[option1="'+ col +'"]').attr('selected', 'selected').val();
   $(this).parents('.items_grid').find('.variantbox').val(selected_val);
});
$(".custom_swatch span").click(function(){  
   var col = $(this).attr("data-color");
   var selected_val = $(this).parents('.items_grid').find('.custom-selector option[option1="'+ col +'"]').attr('selected', 'selected').attr("datavarimg");
   $(this).parents('.items_grid').find('.product_img img').attr('src', selected_val);
});



// collection all page mobile nav

$('.metafield_nav_item').click(function(){  
    $('.metafield_nav_item').removeClass("active_nav");  
    $(this).addClass("active_nav");  
});
$(document).on('click', '.metafield_nav_item a[href^="#"]', function (event) {
  event.preventDefault();
  $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top - 140
  }, 500);
}); 



// collection all page compare popup

jQuery(document).ready(function($){
  //open popup
  $('.popup-trigger').on('click', function(event){
    event.preventDefault();
    $('.compare_popup').addClass('showpopup');
  });
  
  //close popup
  $('.compare_popup').on('click', function(event){
    if( $(event.target).is('.compare_popup_close') || $(event.target).is('.compare_popup') ) {
      event.preventDefault();
      $(this).removeClass('showpopup');
    }
  });
  //close popup when clicking the esc keyboard button
  $(document).keyup(function(event){
      if(event.which=='27'){
        $('.compare_popup').removeClass('showpopup');
      }
    });
});



// collection all page if cart page enabled

$(document).on("click",".custom_collection",function() {
  var variantid =$(this).parent(".customForm").find('.variantbox').val();
  var var_id = $(this).parent(".customForm").serialize();
  $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: var_id,
      success:function(result){
        window.location.href="/cart";  
      } 
  });   
});

// header js for transparent
 $('.mm-header').click(function () {
   if($(this).hasClass('header-active')) {
     $(this).parents('#shopify-section-header').addClass('shopify-section-header-sticky');
   }
    else {
     $(this).parents('#shopify-section-header').removeClass('shopify-section-header-sticky');
  }
});


function socialgrid() {
 $('.infusionslider').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0506/9039/2238/files/image_2021_11_11T04_38_04_037Z.png?v=1636605516'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0506/9039/2238/files/image_2021_11_11T04_38_37_538Z.png?v=1636605573'>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 750,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    }
  ]
});
}
socialgrid();
document.addEventListener("shopify:section:load", socialgrid); 

/******* infusion smart showerhead slider *******/
function smartshower() {
 $('.smartshower').slick({
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/0506/9039/2238/files/image_2021_11_11T04_38_04_037Z.png?v=1636605516'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/0506/9039/2238/files/image_2021_11_11T04_38_37_538Z.png?v=1636605573'>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 750,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        rows: 2,
        autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2,
        arrows: false
      }
    }
  ]
});
}
smartshower();
document.addEventListener("shopify:section:load", smartshower);  


var $question_one = $('.infusion_accordion_head');
var $answer_one = $('.infusion_accordion_body');
$question_one.click(function() {
  $answer_one.slideUp();
  if ($(this).hasClass('active')) {
    $(this).removeClass('active').next($answer_one).slideUp();
  } else {
    $question_one.removeClass('active');
    $(this).addClass('active').next($answer_one).slideDown();
  }
});

/**** https://gethai.com/products/relax for this product ***/
$('.infusion-three-icons b').each(function() {
  if ($(this).index() !== 2) {
    $(this).contents().unwrap();
  }
});

